(() => {
  if (window.joffzHeaderNavigationLoaded) return;
  window.joffzHeaderNavigationLoaded = true;
  function init(scope = document) {
    scope.querySelectorAll('[data-joffz-header]').forEach(header => {
      if (header.dataset.navigationReady) return;
      header.dataset.navigationReady = 'true';
      const id = header.dataset.joffzHeader;
      const q = name => header.querySelector(`.${name}-${id}`);
      const parents = [...header.querySelectorAll(`.header-menu-item-main-${id}`)];
      const burger = q('header-menu-burger');
      const mobile = q('header-menu-mobile');
      const mq = matchMedia('(min-width: 1024px)');
      let previousOverflow = '';
      let openMobile = false;
      const measure = () => header.style.setProperty('--joffz-header-bottom', `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
      const setDesktop = (item, open) => {
        item.classList.toggle('active', open);
        item.querySelector('.joffz-nav-trigger')?.setAttribute('aria-expanded', String(open));
        const panel = item.querySelector(`.header-submenu-${id}`);
        if (panel) panel.inert = !open;
      };
      const closeDesktop = () => parents.forEach(item => setDesktop(item, false));
      const setMobile = (open, restore = false) => {
        if (!mobile || !burger) return;
        if (open && !openMobile) previousOverflow = document.body.style.overflow;
        if (!open && openMobile) document.body.style.overflow = previousOverflow;
        openMobile = open;
        header.classList.toggle('open', open);
        burger.setAttribute('aria-expanded', String(open));
        mobile.setAttribute('aria-hidden', String(!open));
        mobile.inert = !open;
        if (open) { measure(); document.body.style.overflow = 'hidden'; closeDesktop(); }
        if (restore) burger.focus();
      };
      parents.forEach(item => {
        const trigger = item.querySelector('.joffz-nav-trigger');
        if (!trigger) return;
        let closeTimer;
        let openedByHover = false;
        setDesktop(item, false);
        item.addEventListener('mouseenter', () => { clearTimeout(closeTimer); if (mq.matches && matchMedia('(hover: hover)').matches) { closeDesktop(); measure(); setDesktop(item, true); openedByHover = true; } });
        item.addEventListener('mouseleave', () => { closeTimer = setTimeout(() => { if (!item.contains(document.activeElement)) setDesktop(item, false); }, 200); });
        trigger.addEventListener('click', () => { const open = openedByHover || trigger.getAttribute('aria-expanded') !== 'true'; openedByHover = false; closeDesktop(); measure(); setDesktop(item, open); });
        trigger.addEventListener('keydown', event => { if (event.key === 'ArrowDown') { event.preventDefault(); closeDesktop(); setDesktop(item, true); item.querySelector(`.header-submenu-${id} a`)?.focus(); } });
        item.addEventListener('focusout', () => requestAnimationFrame(() => { if (!item.contains(document.activeElement)) setDesktop(item, false); }));
      });
      burger?.addEventListener('click', () => setMobile(!openMobile));
      mobile?.querySelectorAll(`.header-mobile-submenu-${id}`).forEach(panel => {
        panel.hidden = true;
        const wrapper = panel.previousElementSibling;
        if (!wrapper) return;
        const title = wrapper.querySelector('.joffz-mobile-title');
        const icon = wrapper.querySelector(`.header-menu-link-open-${id}`);
        const toggle = () => {
          panel.hidden = !panel.hidden;
          for (const el of [title, icon]) el?.setAttribute('aria-expanded', String(!panel.hidden));
          const vertical = icon?.querySelector('path');
          if (vertical) vertical.style.opacity = panel.hidden ? '1' : '0';
        };
        title?.addEventListener('click', toggle);
        if (icon) {
          icon.setAttribute('role', title ? 'presentation' : 'button');
          icon.setAttribute('tabindex', title ? '-1' : '0');
          if (title) icon.setAttribute('aria-hidden', 'true');
          else icon.setAttribute('aria-label', wrapper.querySelector('a')?.textContent.trim() || 'Menu');
          icon.setAttribute('aria-expanded', 'false');
          icon.addEventListener('click', toggle);
          icon.addEventListener('keydown', event => { if (['Enter', ' '].includes(event.key)) { event.preventDefault(); toggle(); } });
        }
      });
      header.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          const active = parents.find(item => item.classList.contains('active'));
          closeDesktop();
          if (openMobile) setMobile(false, true);
          else active?.querySelector('.joffz-nav-trigger')?.focus();
        }
        if (event.key === 'Tab' && openMobile) {
          const focusable = [...header.querySelectorAll('a[href],button,input:not([type="hidden"]),[tabindex="0"]')].filter(el => !el.closest('[hidden],[inert]') && el.getClientRects().length);
          const first = focusable[0], last = focusable.at(-1);
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        }
      });
      document.addEventListener('click', event => { if (!header.contains(event.target)) { closeDesktop(); if (openMobile) setMobile(false); } });
      header.addEventListener('click', event => { if (event.target.closest('[data-joffz-search-open], #cart-icon-bubble')) { setMobile(false); closeDesktop(); } });
      document.addEventListener('joffz:search-open', () => { setMobile(false); closeDesktop(); });
      mq.addEventListener('change', () => { setMobile(false); closeDesktop(); measure(); });
      window.addEventListener('resize', measure, { passive: true });
      window.addEventListener('scroll', measure, { passive: true });
      measure();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

